import _ from "lodash";
import { parseConsumptionCode } from '@/plans/EVENT_SAAS/helper/parse';

export default (planList) => {
  return planList.forEach((item) => {
    if (item.isPPA) {
      const { plan_code, attendees } = parseConsumptionCode(item.plan_code);
      item.plan_code = plan_code;
      item.cartInfo && attendees && (item.cartInfo.selected_number = _.parseInt(attendees));
    }
  });
}
